module.exports = __webpack_public_path__ + "img/FB_Info_Game_Page_5.a73c3fa8.png";